import React from 'react';


import Header from '../Components/Header';
import Login from '../Components/Login';




function Admin() {
  return (
    <body className="bg-default dark:bg-gray-800">
      <Header />
      <div >
       <Login/>
      </div>
     
    </body>
  );
}

export default Admin;
